import { SIGN_IN, SIGN_OUT, UPDATE_OFFSET, SET_SCREEN_SCROLL_OFFSET, SET_CURRENT_PAGINATION_PAGE } from './constants'

export const signIn = user => ({
  type: SIGN_IN,
  payload: user,
})

export const signOut = () => ({
  type: SIGN_OUT,
})

export const updateOffset = offset => ({
  type: UPDATE_OFFSET,
  payload: offset,
})

export const setScreenScrollOffset = ({ screen, offset }) => ({
  type: SET_SCREEN_SCROLL_OFFSET,
  payload: {
    screen,
    offset
  }
})

export const setCurrentPaginationPage = ({ screen, page }) => ({
  type: SET_CURRENT_PAGINATION_PAGE,
  payload: {
    screen,
    page,
  }
})
